module.exports = __webpack_public_path__ + "img/smartrecruiters.17c66c94.png";